module.exports = __webpack_public_path__ + "img/cpany13.89fc7bf9.png";